import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';
import { firstUserErrorCode } from '@/graphql/errors';
import { PAY_INVOICE } from '@/graphql/mutations/billing';
import type { TransactionOutcome } from './use-start-checkout';

type UsePayInvoiceResult = { payInvoice: (invoiceId: string) => Promise<TransactionOutcome> };

export function usePayInvoice(): UsePayInvoiceResult {
  const [mutate] = useMutation(PAY_INVOICE);

  const payInvoice = useCallback(
    async (invoiceId: string): Promise<TransactionOutcome> => {
      const { data } = await mutate({ variables: { input: { invoiceId } } });
      const payload = data?.payInvoice;
      if (payload?.transactionId) return { transactionId: payload.transactionId, errorCode: null };
      return {
        transactionId: null,
        errorCode: firstUserErrorCode(payload?.userErrors) ?? 'UNKNOWN',
      };
    },
    [mutate],
  );

  return { payInvoice };
}
